import React, { useEffect, useRef, useState } from 'react';
import './levels.css';
import { useNavigate } from 'react-router-dom';

import Settings from '../components/common/settings';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const Levels = () => {
  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  const lockedAudio = useRef(new Audio(lockedSound));
  const settingsAudio = useRef(new Audio(settingsSound));

  useEffect(() => {
    setLoaded(true);
  }, []);

  const playLockedSound = () => {
    lockedAudio.current.currentTime = 0;
    lockedAudio.current.play().catch(() => {});
  };

  const playSettingsSound = () => {
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  return (
    <section className='section2'>

      <div className="overlay"></div>
      <div className="fog"></div>
      <div className="flicker-overlay"></div>

      <div className='levelsnav'>

        <button
          className='backbt'
          onClick={() => {
            playSettingsSound();
            navigate(-1);
          }}
        >
          BACK
        </button>

        <h1 className='mysteryhotel'>
          MYSTERY HOTEL
        </h1>

        <div
          className='settings'
          onClick={openSettingsMenu}
        />

      </div>

      <h1 className='pickurroom'>
        PICK YOUR ROOM
      </h1>

      <div className='levelsdiv'>

        <div className={`level1 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

        <div className={`level2 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

        <div className={`level3 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

        <div className={`level4 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

        <div className={`level5 ${loaded ? 'enter' : ''}`} onClick={() => navigate('/story')} />

        <div className={`level6 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

        <div className={`level7 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className='lock'></div>
        </div>

      </div>

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

    </section>
  );
};

export default Levels;